import { Point } from 'geojson';
import { create } from 'zustand';

import { CreateSignState } from '@/types/CreateSignState';
import { CreateSignStep } from '@/types/CreateSignStep';
import { LocationInputMode } from '@/types/LocationInputMode';

const defaultCreateSignState: Omit<CreateSignState, 'actions'> = {
  geometry: undefined,

  supportId: undefined,

  locationInputMode: LocationInputMode.DEFAULT,

  step: CreateSignStep.LOCATION,

  lastSupportLayerUpdate: new Date().getTime(),
};

export const useCreateSignStore = create<CreateSignState>()((set) => ({
  ...defaultCreateSignState,

  actions: {
    setGeometry: (geometry: Point) => set({ geometry }),

    setSupportId: (supportId: string | undefined) => set({ supportId }),

    setStep: (step: CreateSignStep) => set({ step }),
    previousStep: () => set(({ step: currentStep }) => ({ step: Math.max(0, currentStep - 1) })),
    nextStep: () =>
      set(({ step: currentStep }) => ({ step: Math.min(Object.values(CreateSignStep).length, currentStep + 1) })),

    setLocationInputMode: (locationInputMode: LocationInputMode) => set({ locationInputMode }),

    reloadSupportLayer: () =>
      setTimeout(() => {
        set(() => ({ lastSupportLayerUpdate: new Date().getTime() }));
      }, 1000),

    resetStore: () => set(defaultCreateSignState),
  },
}));
